<template>
  <div>
    <NavBar></NavBar>
    <h2 class="mt-3"><i>Materias primas en formato completo</i></h2>
    <div class="container mx-auto my-2">
      <div class="row">
        <div class="card text-bg-dark my-1 mx-auto col-sm-4" style="max-width: 18rem;"
          @click.prevent="goToSheetCompSection()">
          <img src="../assets/lamina.png" class="rounded card-img-top img-fluid mt-3" style="width: 100%; height: 100%"
            :alt="rawMaterial" />
          <div class="card-body">
            <h5 class="card-title">LÁMINA METÁLICA EN FORMATO COMPLETO</h5>
            <p class="card-text"><i>(HR, CR, Alfajor, Inoxidable, Aluminio, Antidesgaste)</i></p>
          </div>
        </div>
        <div class="card text-bg-dark my-1 mx-auto col-sm-4" style="max-width: 18rem;"
          @click.prevent="goToProfileCompSection()">
          <img src="../assets/perfil.png" class="rounded card-img-top img-fluid mt-3" style="width: 100%; height: 100%"
            :alt="rawMaterial" />
          <div class="card-body">
            <h5 class="card-title">PERFIL ESTRUCTURAL EN FORMATO COMPLETO</h5>
            <p class="card-text"><i>(Canal U, Vigas IPE - HEA - WF, Ángulos, Platinas)</i></p>
          </div>
        </div>
        <div class="card text-bg-dark mb-3 my-1 mx-auto col-sm-4" style="max-width: 18rem;"
          @click.prevent="goToTubeCompSection()">
          <img src="../assets/tuberia.png" class="rounded card-img-top img-fluid mt-3" style="width: 100%; height: 100%"
            :alt="rawMaterial" />
          <div class="card-body">
            <h5 class="card-title">TUBERÍA METÁLICA EN FORMATO COMPLETO</h5>
            <p class="card-text"><i>(HR, CR, Inoxidable)</i></p>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <h2><i>MATERIAS PRIMAS PROCESADAS</i></h2>
      <p><i>(LÁMINAS METÁLICAS / PERFILES / TUBOS)</i></p>
    </div>
    <FamiliesCards></FamiliesCards>
  </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import FamiliesCards from "@/components/GeneralComponents/FamiliesCardsComponent.vue";

export default {
  name: "FamilyView",
  data() {
    return {};
  },
  methods: {
    goToSheetCompSection() {
      this.$router.push("/CompleteSheetSection")
    },
    goToProfileCompSection() {
      this.$router.push("/CompleteProfileSection")
    },
    goToTubeCompSection() {
      this.$router.push("/CompleteTubeSection")
    },
  },
  components: {
    NavBar,
    FamiliesCards,
  },
};
</script>
<style scoped></style>